import React, { Component } from 'react';
import style from './../../component/common/style/index.scss';
import { Tooltip} from './../../component/common/ToolTip/ToolTip';
import CONST from '../constants'
const gradeScale = ['Maximum mark', 'Assessment objective', 'Year average', 'Group average'];
function groupRowclass(params) {
    return (gradeScale.some(item => params.value === item)) ? style.groupedRow : "";
}
function colSpanclass(params) {
    return (gradeScale.some(item => params.value === item)) ? 2 : 1;
}
function questioncellClassColorblind(params) {
    let percentage = (typeof params.data.markPercentage != "undefined" && typeof params.data.markPercentage[params.colDef.field] != "undefined") ? params.data.markPercentage[params.colDef.field]:'--'
    return (percentage < CONST.LOW_PERCENTGE) ? [style.raRedcolorblind, style.centerCls, style.fontCls].join(' ') : (percentage >= CONST.LOW_PERCENTGE && percentage < CONST.AVG_PERCENTAGE) ? [style.raYellowcolorblind, style.centerCls, style.fontCls].join(' ') : [style.centerCls, style.fontCls].join(" ");
}
function questioncellClass(params) {
    let percentage = (typeof params.data.markPercentage!= "undefined" && typeof params.data.markPercentage[params.colDef.field] != "undefined") ? params.data.markPercentage[params.colDef.field] : '--'
    return (percentage < CONST.LOW_PERCENTGE) ? [style.raRed, style.centerCls, style.fontCls].join(' ') : (percentage >= CONST.LOW_PERCENTGE && percentage < CONST.AVG_PERCENTAGE) ? [style.raYellow, style.centerCls, style.fontCls].join(' ') : [style.centerCls, style.fontCls].join(" ");
}

let questionConfig = {
  
    fixedcolumndefinition: {

        firstName: { headerName: "First name", 
        field: "firstName", 
        unSortIcon: true,
         sortingOrder: ['asc'],
          cellClass: [style.fontCls].join(" "),
           pinned: 'left',
            sortable: true,
             minWidth: 100,
             wrapText: true,
             autoHeight: true,
             cellRenderer: (params) => {
                 let id = params.data.id;
                 let name = params.data.firstName;

                 return `<a href=/student/${id}  class="uIdcolumn" >${name}</a>`;

             }
             },
        lastName: { headerName: "Last name",
         field: "lastName",
          unSortIcon: true,
           sort: 'asc',
            sortingOrder: ['asc',null],
             cellClass: groupRowclass,
              pinned: 'left',
               sortable: true,
                minWidth: 100 ,
                wrapText: true,
                autoHeight: true,
                cellRenderer: (params) => {
                    let id = params.data.id;
                    let name = params.data.lastName;
                    let classes = groupRowclass(params);
                    let template = (gradeScale.some(item => params.value === item)) ? `<span class=${classes}>${name}</span>` : `<a href=/student/${id}  class="uIdcolumn" >${name}</a>`
                    return template;
                }
            },
        mark: { headerName: "Mark", autoHeight: true, field: "mark", unSortIcon: true, sortingOrder: ['asc'], cellClass: [style.centerCls, style.fontCls].join(" "), sortable: true, minWidth: 100 },
        steps: { headerName: "Steps", autoHeight: true,field: "steps",  unSortIcon: true, sortingOrder: ['asc'],cellClass: [style.centerCls, style.fontCls].join(" "), sortable: true, minWidth: 100 },
        percentage: {
            headerName: "Percentage", autoHeight: true, unSortIcon: true, sortingOrder: ['asc'],field: "percentage", cellClass: [style.centerCls, style.fontCls].join(" "), sortable: true, minWidth: 130,
        valueGetter(a){
            return (a.data.percentage != "" && a.data.percentage > 0)?`${a.data.percentage} %`:""
        }},
        target: { headerName: "Target", autoHeight: true,field: "target", unSortIcon: true, sortingOrder: ['asc'],cellClass: [style.centerCls, style.fontCls].join(" "), sortable: true, minWidth: 70 },
        indicativeGrade: { headerName: "Indicative grade", autoHeight: true, unSortIcon: true, sortingOrder: ['asc'], field: "indicativeGrade", cellClass: [style.centerCls, style.fontCls].join(" "), sortable: true, minWidth: 180 },
        courseTarget: { headerName: "Course target", autoHeight: true, unSortIcon: true, sortingOrder: ['asc'], field: "stepTarget", cellClass: [style.centerCls, style.fontCls].join(" "), sortable: true, minWidth: 150 },
    },
    fixedcolumn: ['firstName', 'lastName', 'target', 'indicativeGrade', 'stepTarget','gradeTarget'],
    dynamicColumn: ['mark', 'steps', 'percentage'] ,
    columnsTitle: {
        firstName: 'First name', lastName: 'Last name', mark: 'Mark', steps: 'Steps', percentage: 'Percentage', target: 'Target', indicativeGrade:'Indicative grade',
        q1:'Q1',q2:'Q2',q3:'Q3',q4:'Q4',q5:'Q5',q6:'Q6',q7:'Q7',q8:'Q8',q9:'Q9',q10:'Q10',q11:'Q11',q12:'Q12',q13:'Q13',
        q14:'Q14',q15:'Q15',q16:'Q16',q17:'Q17',q18:'Q18',q19:'Q19',q20:'Q20',q21:'Q21',q22:'Q22',q23:'Q23',q24:'Q24',q25:'Q25',
        q26: 'Q26', q27: 'Q27', q28: 'Q27', q29: 'Q29', q30: 'Q30', "maximumMark": "Maximum mark", "assessmentObjective":"Assessment objective",
        "GroupAverage": "Group average", "YearAverage": "Year average","courseTarget":"Course target"
    }

   };

export default questionConfig;

function customTooltip(tooltip){

        return Tooltip(tooltip);
       }

export const convertColumndef = (isColorblind, viewBy, questionConfig, customColumn) => {

    let columnsArray = [],descriptionArray={};

    questionConfig.questionDescription.map((description)=>{
        Object.keys(description).map((key)=>{
           descriptionArray[key] = description[key];
        })
    })
      
    let cellClass = (isColorblind == false) ? questioncellClass : questioncellClassColorblind;
    customColumn.map((column)=>{
        if(typeof questionConfig.fixedcolumndefinition[column] !="undefined"){
            if (column =="courseTarget"){
                if (viewBy == "steps") {
                    questionConfig.fixedcolumndefinition[column]['field'] = 'stepTarget'
                } else {
                    questionConfig.fixedcolumndefinition[column]['field'] = 'gradeTarget'
                }
            }
            columnsArray.push(questionConfig.fixedcolumndefinition[column])
        } else{
            let questionDesc = (typeof descriptionArray[column] != 'undefined') ? descriptionArray[column]:[]
            columnsArray.push({
                headerName: column.charAt(0).toUpperCase() + column.slice(1),
                field: column,
                minWidth: 70,
                cellClass: cellClass,
                headerTooltip: customTooltip(questionDesc),
               
            })
        }

    })
    
    return columnsArray;   
}

export const convertRowData = (isColorblind, questionConfig) => {
    let rowsArray = [], pinnedTopRow=[];
    questionConfig.questionGradeScale.map((val) => {
        val['firstName'] ='';
        val['lastName'] = questionConfig.columnsTitle[val['gradeKey']];
        //val['rowHeight']=36;
        pinnedTopRow.push(val);
    })
    questionConfig.questionData.map((val) => {
       // val['rowHeight'] = 36;
        rowsArray.push(val);
    })
    return { rowsArray: rowsArray, pinnedTopRow: pinnedTopRow};
}
export const GenerateCustomColumn = (questiondata,viewBy)=>{
    let data = { ...questiondata}
    let dynamicColumn= ['mark', 'steps', 'percentage'];
    data.defaultColumns.splice(data.defaultColumns.indexOf('gradeKey'),1);
    let index = dynamicColumn.indexOf(viewBy);
    dynamicColumn.splice(index, 1);
    let customArray =[];
    data.defaultColumns.map((val)=>{
        let isExist = dynamicColumn.indexOf(val);
        if (isExist == -1){
             customArray.push(val);
        }
    })
    return customArray;
}
